module.exports = __webpack_public_path__ + "img/logo_donya.ba4df171.png";